import { Reveal } from "./Reveal";
import { PawWatermark } from "./Paws";
import { site, legal } from "../data/siteConfig";
import { ArrowLeft } from "lucide-react";

const Block = ({ block }) => {
    if (typeof block === "string")
        return <p className="leading-relaxed text-stone-600">{block}</p>;
    if (block.sub)
        return (
            <h3 className="pt-2 font-serif text-xl font-semibold text-[#1c1917] sm:text-2xl">
                {block.sub}
            </h3>
        );
    if (block.list)
        return (
            <ul className="space-y-2.5">
                {block.list.map((item) => (
                    <li
                        key={item}
                        className="flex items-start gap-3 leading-relaxed text-stone-600"
                    >
                        <span
                            className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-fern"
                            aria-hidden="true"
                        />
                        {item}
                    </li>
                ))}
            </ul>
        );
    if (block.closing)
        return (
            <p className="pt-2 font-serif text-xl italic leading-relaxed text-[#1c1917] sm:text-2xl">
                {block.closing}
            </p>
        );
    return null;
};

export const TermsPage = () => (
    <section
        className="relative overflow-hidden bg-cream pb-24 pt-28 text-[#1c1917] sm:pb-32 sm:pt-36"
        data-testid="terms-page"
    >
        <PawWatermark tone="light" />
        <div className="relative mx-auto max-w-3xl px-5 sm:px-8">
            <Reveal>
                <a
                    href="#top"
                    data-testid="terms-back-link"
                    className="inline-flex items-center gap-2 text-sm font-semibold text-fern transition-colors duration-200 hover:text-[#1c1917]"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back to homepage
                </a>
            </Reveal>
            <Reveal delay={0.05}>
                <p className="mt-8 font-mono text-xs uppercase tracking-[0.3em] text-fern sm:text-sm">
                    {site.name}
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <h1
                    className="mt-4 max-w-3xl font-serif text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl"
                    data-testid="terms-title"
                >
                    Terms &amp; Conditions.
                </h1>
            </Reveal>
            <Reveal delay={0.15}>
                <div className="mt-6 space-y-4 text-base sm:text-lg">
                    {legal.termsIntro.map((p) => (
                        <p
                            key={p.slice(0, 32)}
                            className="leading-relaxed text-stone-600"
                        >
                            {p}
                        </p>
                    ))}
                </div>
            </Reveal>

            <div className="mt-14 space-y-12">
                {legal.termsSections.map((s, i) => (
                    <Reveal key={s.title} delay={0.03}>
                        <section data-testid={`terms-section-${i + 1}`}>
                            <h2 className="flex items-baseline gap-4 font-serif text-2xl font-semibold sm:text-3xl">
                                <span className="shrink-0 font-mono text-xs uppercase tracking-[0.25em] text-fern">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                {s.title}
                            </h2>
                            <div className="mt-4 space-y-4">
                                {s.blocks.map((b, j) => (
                                    <Block key={j} block={b} />
                                ))}
                            </div>
                        </section>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.05}>
                <a
                    href="#top"
                    data-testid="terms-back-bottom"
                    className="mt-14 inline-flex items-center gap-2 rounded-full border border-stone-500/60 bg-cream/60 px-8 py-4 text-base font-semibold text-[#1c1917] backdrop-blur-sm transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-[#1c1917] hover:bg-white"
                >
                    <ArrowLeft className="h-4 w-4" />
                    Back to homepage
                </a>
            </Reveal>
        </div>
    </section>
);
